import React, { useMemo, useState } from "react";
import FormularioProfesor from "./FormularioProfesor";
import MisPedidos from "./MisPedidos";
import CentroNotificaciones from "./CentroNotificaciones";
import "./VistaDocenteTabs.css";

export default function VistaDocenteTabs({ onCerrarSesion }) {
  const [pestanaActiva, setPestanaActiva] = useState("nuevo"); // 'nuevo' | 'mis'

  const nombreProfesor = useMemo(() => {
    return localStorage.getItem("profesorNombre") || "Docente";
  }, []);

  const areaProfesor = useMemo(() => {
    return (localStorage.getItem("profesorArea") || "").toLowerCase();
  }, []);

  const profesorId = useMemo(() => {
    return Number(localStorage.getItem("profesorId") || 0);
  }, []);

  const cerrarSesionSeguro = () => {
    // Mantiene comportamiento seguro sin romper nada.
    // Si tu app ya maneja el cierre con un callback, úsalo.
    if (typeof onCerrarSesion === "function") {
      onCerrarSesion();
      return;
    }

    // Fallback por si todavía no pasás onCerrarSesion:
    localStorage.removeItem("profesorId");
    localStorage.removeItem("profesorNombre");
    localStorage.removeItem("profesorArea");
    window.location.reload();
  };

  return (
    <div className="docente-fondo">
      <header className="docente-header">
        <div className="docente-brand">
          <div className="docente-logo">FB</div>
          <div>
            <h1 className="docente-titulo">FBDesk</h1>
            <p className="docente-subtitulo">
              Panel del docente · Pedidos y solicitudes
            </p>
          </div>
        </div>

        <div className="docente-user">
          <CentroNotificaciones rol="docente" usuarioId={profesorId} />

          <div className="docente-userinfo">
            <div className="docente-bienvenido">Bienvenido,</div>
            <div className="docente-nombre">{nombreProfesor}</div>
            {areaProfesor && (
              <div className="docente-area">
                Área: <span>{areaProfesor}</span>
              </div>
            )}
          </div>

          <button className="docente-btn-salir" onClick={cerrarSesionSeguro}>
            Cerrar sesión
          </button>
        </div>
      </header>

      <main className="docente-main">
        <div className="docente-card">
          <div className="docente-tabs">
            <button
              className={
                pestanaActiva === "nuevo"
                  ? "docente-tab docente-tab-activa"
                  : "docente-tab"
              }
              onClick={() => setPestanaActiva("nuevo")}
              type="button"
            >
              Nuevo pedido
            </button>

            <button
              className={
                pestanaActiva === "mis"
                  ? "docente-tab docente-tab-activa"
                  : "docente-tab"
              }
              onClick={() => setPestanaActiva("mis")}
              type="button"
            >
              Mis pedidos
            </button>

            <div className="docente-tab-linea" />
          </div>

          <div className="docente-contenido">
            {/* ✅ NO tocamos lógica: solo renderizamos los componentes existentes */}
            {pestanaActiva === "nuevo" && (
              <div className="docente-seccion anim-entrada">
                <h2 className="docente-h2">Cargar un nuevo pedido</h2>
                <p className="docente-p">
                  Completá los campos y enviá tu solicitud al área de soporte.
                </p>

                <div className="docente-bloque">
                  <FormularioProfesor />
                </div>
              </div>
            )}

            {pestanaActiva === "mis" && (
              <div className="docente-seccion anim-entrada">
                <h2 className="docente-h2">Mis pedidos realizados</h2>
                <p className="docente-p">
                  Revisá el estado de tus pedidos y modificá solo los que estén
                  en <strong>pendiente</strong>.
                </p>

                <div className="docente-bloque">
                  <MisPedidos />
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      <footer className="docente-footer">
        <span>FBDesk</span> · Soporte técnico e inventario escolar
      </footer>
    </div>
  );
}
